/**
 * Compute SHA-256 hash of a File in the browser; returns hex string.
 * @param {File} file
 * @returns {Promise<string>}
 */
export function computeFileSha256(file) {
  return file.arrayBuffer().then((buffer) => {
    return crypto.subtle.digest('SHA-256', buffer)
  }).then((hashBuffer) => {
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  })
}
